import { render, staticRenderFns } from "./videoAd.vue?vue&type=template&id=45a220a0&scoped=true&"
import script from "./videoAd.vue?vue&type=script&lang=js&"
export * from "./videoAd.vue?vue&type=script&lang=js&"
import style0 from "./videoAd.vue?vue&type=style&index=0&id=45a220a0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a220a0",
  null
  
)

export default component.exports